import { ValidationError, Validator } from 'class-validator';
import { FormDataBase } from './FormDataBase';
import { FormFieldState } from './FormFieldState';

export abstract class FormStateBase {
    // tslint:disable-next-line: variable-name
    private _form: FormStateBase | null = null;
    // tslint:disable-next-line: variable-name
    private _isValid: boolean = false;

    get isValid(): boolean {
        return this._isValid;
    }

    setForm(form: FormStateBase) {
        this._form = form;
    }

    updateValidationErrors(validationErrors: ValidationError[] = []) {

        const form: any = this._form;
        let isValid = true;

        Object.keys(form as any).forEach((key: string) => {
            const fieldState: FormFieldState = form[key];

            const validationError: ValidationError | undefined = this._getValidationError(key, validationErrors);

            Object.assign(fieldState, {
                state: validationError === undefined,
                message: validationError ? Object.values(validationError.constraints!)[0] : '',
                rules: [!validationError || Object.values(validationError!.constraints!)[0]],
            });

            isValid = isValid && (validationError === undefined);
        });

        this._isValid = isValid;

    }

    resetState(): void {
      const form: any = this._form;

      Object.keys(form as any).forEach((key: string) => {
        if (form[key] instanceof FormFieldState) {
          const fieldState: FormFieldState = form[key];
          Object.assign(fieldState, {
            state: null,
            message: '',
            rules: [false],
          });
        }
      });

      this._isValid = false;
    }

    async validate(doValidation: boolean, formData: FormDataBase): Promise<boolean | undefined> {
      if (doValidation) {
        const validator: Validator = new Validator();
        const validationErrors: ValidationError[] = await validator.validate(formData, { forbidUnknownValues: true });
        this.updateValidationErrors(validationErrors);
        return this._isValid && (validationErrors.length === 0);
      }
    }

    private _getValidationError(key: string, validationErrors: ValidationError[]): ValidationError | undefined {
        return validationErrors.find((error) => error.property === key);
    }

}
